import http from '@/services/AuthService'

export default {
  getSummary() {
    return http.get('/floodReliefMission/summary')
  },
  getMyRequests(params = {}) {
    return http.get('/floodReliefMission/myRequests', { params })
  },
  getRequestDetail(id) {
    return http.get(`/floodReliefMission/requestDetail/${id}`)
  },
  getRequestForEdit(encryptedId) {
    return http.get(`/floodReliefMission/requestForEdit/${encryptedId}`)
  },
  updateRequest(encryptedId, data) {
    return http.post(`/floodReliefMission/updateRequest/${encryptedId}`, data)
  },
  // Public search - no auth required
  publicSearch(search, page = 1) {
    return http.get('/floodReliefMission/publicSearch', { params: { search, page } })
  }
}
